/**
 * IntelliGems A/B — Most loved styles (PDP)
 *
 * Control: data-ig-most-loved-styles="false"
 * Variant: document.body.setAttribute('data-ig-most-loved-styles', 'true');
 * Dev: ?most_loved_styles_test=b
 *
 * Soft-nav uses full product HTML (reliable across templates) + hover prefetch.
 * Section is repositioned above FAQ on all PDPs and filtered by product gender.
 */
(function () {
  'use strict';

  if (window.__igMostLovedStylesInit) return;
  window.__igMostLovedStylesInit = true;

  var BODY_ATTR = 'data-ig-most-loved-styles';
  var ROOT_SEL = '[data-ig-most-loved-styles-root]';
  var CARD_SEL = '[data-ig-most-loved-card]';
  var busy = false;
  var cache = {};
  var prefetching = {};
  var activeController = null;
  var parkHost = null;
  var loadingRoots = {};

  function isTruthy(value) {
    var n = String(value || '')
      .trim()
      .toLowerCase();
    return n === 'true' || n === '1' || n === 'on' || n === 'yes' || n === 'b';
  }

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('most_loved_styles_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isVariantB() {
    if (isDevVariantB()) return true;
    return !!(document.body && isTruthy(document.body.getAttribute(BODY_ATTR)));
  }

  function applyDev() {
    if (!isDevVariantB() || !document.body) return;
    if (!isTruthy(document.body.getAttribute(BODY_ATTR))) {
      document.body.setAttribute(BODY_ATTR, 'true');
    }
  }

  function formatCount(n) {
    var num = parseInt(n, 10);
    if (isNaN(num)) return String(n || '');
    return num.toLocaleString('en-US');
  }

  function money(cents, moneyFormat) {
    var amount = (Number(cents) || 0) / 100;
    var formatted = amount.toFixed(2).replace(/\.00$/, '');
    var format = moneyFormat || '${{amount}}';
    if (format.indexOf('{{amount}}') !== -1) {
      return format.replace('{{amount}}', formatted);
    }
    if (format.indexOf('{{amount_no_decimals}}') !== -1) {
      return format.replace('{{amount_no_decimals}}', String(Math.round(amount)));
    }
    return '$' + formatted;
  }

  function normalizeUrl(url) {
    try {
      var u = new URL(url, window.location.origin);
      return u.pathname + u.search;
    } catch (e) {
      return url;
    }
  }

  function cacheKey(url) {
    return normalizeUrl(url);
  }

  function tagList(product) {
    if (!product) return [];
    if (Array.isArray(product.tags)) {
      return product.tags.map(function (t) {
        return String(t || '')
          .trim()
          .toLowerCase();
      });
    }
    return String(product.tags || '')
      .split(',')
      .map(function (t) {
        return t.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function detectGenderFromProduct(product) {
    // Women-only styles → women. Everything else defaults to men.
    if (womenOnlyProduct(product)) return 'women';

    var tags = tagList(product);
    if (
      tags.indexOf('women') !== -1 ||
      tags.indexOf('woman') !== -1 ||
      tags.indexOf('womens') !== -1
    ) {
      return 'women';
    }
    if (tags.indexOf('men') !== -1 || tags.indexOf('man') !== -1 || tags.indexOf('mens') !== -1) {
      return 'men';
    }

    var title = String((product && product.title) || '').toLowerCase();
    var handle = String((product && product.handle) || '').toLowerCase();
    var type = String((product && product.product_type) || (product && product.type) || '').toLowerCase();
    var blob = title + ' ' + handle + ' ' + type;

    if (/\bwom(?:e)?n'?s?\b|\blady\b/.test(blob)) return 'women';
    if (/\bmen'?s?\b|\bman\b|\bcomfywalk\b|\boxford\b/.test(blob)) return 'men';
    return 'men';
  }

  function getRootGender(root) {
    var activeTab = document.querySelector('.custom-gender-tab.active[data-gender]');
    if (activeTab) {
      return activeTab.getAttribute('data-gender') === 'women' ? 'women' : 'men';
    }

    var path = (window.location.pathname || '').toLowerCase();
    if (/\/products\/[^/]*(woman|women|lady|eloria|solea)/.test(path)) return 'women';
    if (/\/men-|men-casual|\/mens|oxford|comfywalk/.test(path)) return 'men';

    var fromAttr = (root.getAttribute('data-product-gender') || '').toLowerCase();
    if (fromAttr === 'men' || fromAttr === 'women') return fromAttr;

    return 'men';
  }

  function cardsMatchGender(root, gender) {
    var cards = root.querySelectorAll(CARD_SEL);
    if (!cards.length) return false;
    for (var i = 0; i < cards.length; i++) {
      var handle = (cards[i].getAttribute('data-product-handle') || '').toLowerCase();
      var titleEl = cards[i].querySelector('.ig-most-loved-styles__title');
      var title = titleEl ? String(titleEl.textContent || '').toLowerCase() : '';
      var product = { handle: handle, title: title };
      if (!matchesGender(product, gender)) return false;
    }
    return true;
  }

  function genderLabel(gender) {
    return gender === 'men' ? 'MEN' : 'WOMEN';
  }

  function womenOnlyProduct(product) {
    var handle = String((product && product.handle) || '').toLowerCase();
    var title = String((product && product.title) || '').toLowerCase();
    if (
      handle === 'woman-shoes' ||
      handle === 'eloria-warm-supportive-walking-shoes' ||
      handle === 'solea' ||
      handle.indexOf('woman') !== -1 ||
      handle.indexOf('lady') !== -1
    ) {
      return true;
    }
    if (title.indexOf('lady') !== -1 || title.indexOf('woman') !== -1 || title.indexOf('women') !== -1) {
      return true;
    }
    return false;
  }

  function getTopHandles(root, gender) {
    var attr =
      gender === 'men'
        ? root.getAttribute('data-top-handles-men')
        : root.getAttribute('data-top-handles-women');
    var fallback =
      gender === 'men'
        ? 'ultra-1,oxford,v4,comfort-walker,blacksole-1,breathable-casual-shoes,wide-toe-box-barefoot-sneakers,non-slip-classic-orthopaedic-loafer,prostep-orthopedic-loafers,comfy-cloud-ergonomic-supportive-slip-in-shoes'
        : 'woman-shoes,eloria-warm-supportive-walking-shoes,solea';
    return String(attr || fallback)
      .split(',')
      .map(function (h) {
        return h.trim();
      })
      .filter(Boolean);
  }

  function matchesGender(product, gender) {
    if (gender === 'men') {
      if (womenOnlyProduct(product)) return false;
      if (detectGenderFromProduct(product) === 'women') return false;
      return true;
    }
    // Women shelf: women-only / women-tagged products only (no men/unisex fill)
    if (womenOnlyProduct(product)) return true;
    return detectGenderFromProduct(product) === 'women';
  }

  function fetchProductByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(function () {
        return null;
      });
  }

  function fetchTopHandleProducts(handles) {
    return Promise.all(handles.map(fetchProductByHandle)).then(function (products) {
      return products.filter(Boolean);
    });
  }

  function getSectionEl(root) {
    if (!root) return null;
    return (
      root.closest('#shopify-section-ig-most-loved-styles') ||
      root.closest('.ig-most-loved-styles-section') ||
      root.closest('.shopify-section') ||
      root
    );
  }

  function ensureParkHost() {
    if (parkHost && document.body.contains(parkHost)) return parkHost;
    parkHost = document.getElementById('ig-most-loved-styles-park');
    if (!parkHost) {
      parkHost = document.createElement('div');
      parkHost.id = 'ig-most-loved-styles-park';
      parkHost.setAttribute('hidden', '');
      var main = document.getElementById('MainContent');
      if (main && main.parentNode) {
        main.parentNode.insertBefore(parkHost, main.nextSibling);
      } else if (document.body) {
        document.body.appendChild(parkHost);
      }
    }
    return parkHost;
  }

  function findFaqSection() {
    var main = document.getElementById('MainContent');
    if (!main) return null;

    var headings = main.querySelectorAll(
      '.collapsible-content__heading, .collapsible-content h2, h2, h1'
    );
    for (var i = 0; i < headings.length; i++) {
      var text = (headings[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (/got answers/i.test(text) || /^faqs?$/i.test(text) || /frequently asked/i.test(text)) {
        return headings[i].closest('.shopify-section') || headings[i].closest('[id^="shopify-section-"]');
      }
    }

    var caption = main.querySelectorAll('.caption-with-letter-spacing, .collapsible-content__header p');
    for (var c = 0; c < caption.length; c++) {
      if (/got questions/i.test(caption[c].textContent || '')) {
        return caption[c].closest('.shopify-section');
      }
    }

    var collapsible = main.querySelector('.collapsible-content');
    return collapsible ? collapsible.closest('.shopify-section') : null;
  }

  function positionAboveFaq(root) {
    var sectionEl = getSectionEl(root);
    if (!sectionEl) return;

    var faq = findFaqSection();
    var main = document.getElementById('MainContent');
    if (faq && faq.parentNode) {
      if (sectionEl.nextSibling !== faq) {
        faq.parentNode.insertBefore(sectionEl, faq);
      }
      return;
    }

    // No FAQ found — place near end of main (still above footer)
    if (main && sectionEl.parentNode !== main) {
      main.appendChild(sectionEl);
    }
  }

  function parkSection(root) {
    var sectionEl = getSectionEl(root);
    var host = ensureParkHost();
    if (sectionEl && host && sectionEl.parentNode !== host) {
      host.appendChild(sectionEl);
    }
  }

  function getColorOptionIndex(product) {
    var options = product && product.options;
    if (!options || !options.length) return -1;
    for (var i = 0; i < options.length; i++) {
      var name = String(
        typeof options[i] === 'string' ? options[i] : options[i].name || ''
      ).toLowerCase();
      if (name.indexOf('color') !== -1 || name.indexOf('colour') !== -1) return i;
    }
    return -1;
  }

  function variantColor(variant, colorIndex) {
    if (!variant || colorIndex < 0) return '';
    if (variant.options && variant.options[colorIndex] != null) {
      return String(variant.options[colorIndex]);
    }
    var key = 'option' + (colorIndex + 1);
    return String(variant[key] || '');
  }

  function pickPrimaryVariant(product, preferredVariantId) {
    var variants = (product && product.variants) || [];
    if (!variants.length) return null;
    if (preferredVariantId) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(preferredVariantId)) return variants[i];
      }
    }
    for (var j = 0; j < variants.length; j++) {
      if (variants[j].available !== false) return variants[j];
    }
    return variants[0];
  }

  function pickAltColorVariant(product, primaryVariant) {
    if (!product || !primaryVariant) return null;
    var colorIndex = getColorOptionIndex(product);
    if (colorIndex < 0) return null;
    var currentColor = variantColor(primaryVariant, colorIndex);
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (variantColor(v, colorIndex) !== currentColor) return v;
    }
    return null;
  }

  function variantImage(product, variant) {
    var img = '';

    if (variant && variant.featured_image) {
      img = variant.featured_image.src || variant.featured_image;
    }
    if (!img && variant && variant.featured_media) {
      var fm = variant.featured_media;
      if (fm.preview_image && fm.preview_image.src) img = fm.preview_image.src;
      else if (fm.src) img = fm.src;
    }

    // Same-color sibling may carry the image when this size row has none
    if (!img && product && variant) {
      var colorIndex = getColorOptionIndex(product);
      var color = variantColor(variant, colorIndex);
      var variants = product.variants || [];
      for (var i = 0; i < variants.length && !img; i++) {
        var v = variants[i];
        if (colorIndex >= 0 && variantColor(v, colorIndex) !== color) continue;
        if (v.featured_image) img = v.featured_image.src || v.featured_image;
        if (!img && v.featured_media) {
          var m = v.featured_media;
          if (m.preview_image && m.preview_image.src) img = m.preview_image.src;
          else if (m.src) img = m.src;
        }
      }
    }

    // Match variant featured_image id against product.media
    if (!img && product && product.media && variant && variant.featured_image && variant.featured_image.id) {
      for (var mi = 0; mi < product.media.length; mi++) {
        var media = product.media[mi];
        if (media && String(media.id) === String(variant.featured_image.id)) {
          img = (media.preview_image && media.preview_image.src) || media.src || '';
          break;
        }
      }
    }

    if (!img && product) {
      img =
        (product.featured_image && (product.featured_image.src || product.featured_image)) ||
        (product.images && product.images[0]) ||
        '';
    }

    if (img && typeof img === 'string' && img.indexOf('//') === 0) img = 'https:' + img;
    if (img && typeof img === 'object' && img.src) {
      img = img.src;
      if (img.indexOf('//') === 0) img = 'https:' + img;
    }
    return img || '';
  }

  function buildCardHtml(product, opts) {
    opts = opts || {};
    var variant = opts.variant || pickPrimaryVariant(product) || {};
    var price = variant.price != null ? variant.price : product.price;
    var compare =
      variant.compare_at_price != null ? variant.compare_at_price : product.compare_at_price;
    var savePct = 0;
    if (compare && price && compare > price) {
      savePct = Math.round(((compare - price) / compare) * 100);
    }
    var img = variantImage(product, variant);
    var gender =
      opts.genderLabel || genderLabel(detectGenderFromProduct(product) || opts.gender || 'men');
    var count = opts.reviewCount || '1,000+';
    var baseUrl = product.url || '/products/' + product.handle;
    var url = variant.id ? baseUrl.split('?')[0] + '?variant=' + variant.id : baseUrl;
    var starSvg =
      '<svg viewBox="0 0 20 20" width="14" height="14"><path fill="currentColor" d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.5L10 14.77l-4.94 2.94.94-5.5-4-3.9 5.53-.8L10 1.5z"/></svg>';

    return (
      '<a class="ig-most-loved-styles__card" href="' +
      url +
      '" data-ig-most-loved-card data-product-url="' +
      url +
      '" data-product-handle="' +
      (product.handle || '') +
      '" data-product-id="' +
      (product.id || '') +
      '" data-variant-id="' +
      (variant.id || '') +
      '">' +
      '<div class="ig-most-loved-styles__media">' +
      (savePct > 0
        ? '<span class="ig-most-loved-styles__badge">' + savePct + '% OFF</span>'
        : '') +
      (img
        ? '<img class="ig-most-loved-styles__img" src="' +
          img +
          '" alt="' +
          String(product.title || '').replace(/"/g, '&quot;') +
          '" loading="lazy" width="360" height="360">'
        : '') +
      '</div>' +
      '<p class="ig-most-loved-styles__gender">' +
      gender +
      '</p>' +
      '<div class="ig-most-loved-styles__rating" aria-hidden="true">' +
      '<span class="ig-most-loved-styles__stars">' +
      starSvg +
      starSvg +
      starSvg +
      starSvg +
      starSvg +
      '</span>' +
      '<span class="ig-most-loved-styles__count">(' +
      count +
      ')</span>' +
      '</div>' +
      '<h3 class="ig-most-loved-styles__title">' +
      String(product.title || '') +
      '</h3>' +
      '<div class="ig-most-loved-styles__price">' +
      '<span class="ig-most-loved-styles__price-sale">' +
      money(price, opts.moneyFormat) +
      '</span>' +
      (compare && compare > price
        ? '<span class="ig-most-loved-styles__price-compare">' +
          money(compare, opts.moneyFormat) +
          '</span>'
        : '') +
      '</div>' +
      '</a>'
    );
  }

  function uniqueById(products) {
    var seen = {};
    var out = [];
    (products || []).forEach(function (p) {
      if (!p || p.id == null) return;
      var id = String(p.id);
      if (seen[id]) return;
      seen[id] = true;
      out.push(p);
    });
    return out;
  }

  function buildVariantSlots(currentProduct, otherProducts, limit, preferredVariantId) {
    var slots = [];
    var usedVariantIds = {};
    var pushSlot = function (product, variant) {
      if (!product || !variant || slots.length >= limit) return;
      var vid = String(variant.id);
      if (usedVariantIds[vid]) return;
      usedVariantIds[vid] = true;
      slots.push({ product: product, variant: variant });
    };

    // 1–2: current product active color + 2nd color
    if (currentProduct) {
      var currentVariant = pickPrimaryVariant(currentProduct, preferredVariantId);
      pushSlot(currentProduct, currentVariant);
      pushSlot(currentProduct, pickAltColorVariant(currentProduct, currentVariant));
    }

    // 3–4: next product color 1 + color 2 (then more products if needed)
    (otherProducts || []).forEach(function (other) {
      if (slots.length >= limit) return;
      if (currentProduct && String(other.id) === String(currentProduct.id)) return;
      var primary = pickPrimaryVariant(other);
      pushSlot(other, primary);
      pushSlot(other, pickAltColorVariant(other, primary));
    });

    return slots;
  }

  // Client curated overrides: handle → "handle:variantId,handle:variantId,..."
  var CURATED_BY_HANDLE = {
    'ultra-1':
      'summer:,summer:50399849808151,blacksole-1:50399937855767,blacksole-1:50399845384471',
  };

  function parseCuratedSlotsAttr(attr) {
    return String(attr || '')
      .split(',')
      .map(function (pair) {
        var parts = pair.split(':');
        var handle = (parts[0] || '').trim();
        var variantId = (parts[1] || '').trim();
        if (!handle) return null;
        return { handle: handle, variantId: variantId };
      })
      .filter(Boolean);
  }

  function getCuratedSlotDefs(root, productHandle) {
    var fromAttr = parseCuratedSlotsAttr(root && root.getAttribute('data-curated-slots'));
    if (fromAttr.length) return fromAttr;
    var fallback = CURATED_BY_HANDLE[String(productHandle || '').toLowerCase()];
    return parseCuratedSlotsAttr(fallback || '');
  }

  function buildCuratedSlots(defs, limit) {
    var uniqueHandles = [];
    defs.forEach(function (d) {
      if (uniqueHandles.indexOf(d.handle) === -1) uniqueHandles.push(d.handle);
    });
    return fetchTopHandleProducts(uniqueHandles).then(function (products) {
      var byHandle = {};
      (products || []).forEach(function (p) {
        if (p && p.handle) byHandle[p.handle] = p;
      });
      var slots = [];
      defs.forEach(function (d) {
        if (slots.length >= limit) return;
        var product = byHandle[d.handle];
        if (!product) return;
        var variant = pickPrimaryVariant(product, d.variantId || '');
        if (!variant) return;
        slots.push({ product: product, variant: variant });
      });
      return slots;
    });
  }

  function fetchCollectionProducts(handle, limit) {
    if (!handle) return Promise.resolve([]);
    var url =
      '/collections/' +
      encodeURIComponent(handle) +
      '/products.json?limit=' +
      encodeURIComponent(String(limit || 8));
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) return [];
        return res.json();
      })
      .then(function (data) {
        return (data && data.products) || [];
      })
      .catch(function () {
        return [];
      });
  }

  function fetchRecommendations(productId, limit) {
    var url =
      '/recommendations/products.json?product_id=' +
      encodeURIComponent(productId || '') +
      '&limit=' +
      encodeURIComponent(String(limit || 12)) +
      '&intent=related';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        return (data && data.products) || [];
      })
      .catch(function () {
        return [];
      });
  }

  function loadRecommendations(root) {
    var holder = root.querySelector('[data-ig-most-loved-recommendations]');
    var track = root.querySelector('[data-ig-most-loved-track]');
    if (!track) return;

    var productId = root.getAttribute('data-product-id');
    var productHandle = root.getAttribute('data-product-handle') || '';
    var gender = getRootGender(root);
    var loadKey = String(productId || '') + ':' + gender + ':slots';
    if (loadingRoots[loadKey]) return;
    loadingRoots[loadKey] = true;

    var limit = parseInt(root.getAttribute('data-products-to-show'), 10) || 4;
    var reviewCount = root.getAttribute('data-fallback-review-count') || '1,000+';
    var moneyFormat = (window.theme && window.theme.moneyFormat) || undefined;
    var collectionHandle =
      gender === 'men'
        ? root.getAttribute('data-men-collection')
        : root.getAttribute('data-women-collection');

    if (!collectionHandle) {
      collectionHandle = gender === 'men' ? 'orthopedic-shoes' : 'women';
    }

    var topHandles = getTopHandles(root, gender);
    var preferredVariantId = '';
    try {
      preferredVariantId = new URLSearchParams(window.location.search).get('variant') || '';
    } catch (e) {}

    var curatedDefs = getCuratedSlotDefs(root, productHandle);
    if (curatedDefs.length) {
      // Keep data-curated-slots in sync for soft-nav
      root.setAttribute(
        'data-curated-slots',
        curatedDefs
          .map(function (d) {
            return d.handle + ':' + (d.variantId || '');
          })
          .join(',')
      );
      root.setAttribute('data-slot-pattern', 'curated');

      buildCuratedSlots(curatedDefs, limit)
        .then(function (slots) {
          if (!slots.length) {
            if (holder) holder.textContent = '';
            return;
          }
          track.innerHTML = slots
            .map(function (slot) {
              return buildCardHtml(slot.product, {
                variant: slot.variant,
                genderLabel: genderLabel(gender),
                gender: gender,
                reviewCount: reviewCount,
                moneyFormat: moneyFormat,
              });
            })
            .join('');
          root.setAttribute('data-curated-hydrated', '1');
          bindCards(root);
        })
        .finally(function () {
          delete loadingRoots[loadKey];
        });
      return;
    }

    root.setAttribute('data-curated-slots', '');
    root.removeAttribute('data-curated-hydrated');
    root.setAttribute('data-slot-pattern', 'current,current-alt-color,other,other-alt-color');

    var currentFetch = productHandle
      ? fetchProductByHandle(productHandle)
      : Promise.resolve(null);

    Promise.all([
      currentFetch,
      fetchTopHandleProducts(topHandles),
      fetchCollectionProducts(collectionHandle, Math.max(limit * 3, 16)),
      fetchRecommendations(productId, Math.max(limit * 3, 12)),
    ])
      .then(function (results) {
        var currentProduct = results[0];
        var fromHandles = results[1] || [];
        var fromCollection = results[2] || [];
        var recommended = results[3] || [];

        var others = uniqueById(fromHandles.concat(fromCollection).concat(recommended)).filter(
          function (p) {
            if (!p) return false;
            if (currentProduct && String(p.id) === String(currentProduct.id)) return false;
            if (productId && String(p.id) === String(productId)) return false;
            return matchesGender(p, gender);
          }
        );

        var orderedOthers = [];
        topHandles.forEach(function (handle) {
          for (var i = 0; i < others.length; i++) {
            if (others[i].handle === handle) {
              orderedOthers.push(others[i]);
              break;
            }
          }
        });
        others.forEach(function (p) {
          var exists = orderedOthers.some(function (o) {
            return String(o.id) === String(p.id);
          });
          if (!exists) orderedOthers.push(p);
        });

        var slots = buildVariantSlots(currentProduct, orderedOthers, limit, preferredVariantId);
        if (!slots.length) {
          if (holder) holder.textContent = '';
          return;
        }

        var html = slots
          .map(function (slot) {
            return buildCardHtml(slot.product, {
              variant: slot.variant,
              genderLabel: genderLabel(gender),
              gender: gender,
              reviewCount: reviewCount,
              moneyFormat: moneyFormat,
            });
          })
          .join('');
        track.innerHTML = html;
        bindCards(root);
      })
      .finally(function () {
        delete loadingRoots[loadKey];
      });
  }

  function extractMainHtml(pageHtml) {
    if (!pageHtml) return null;
    var match = pageHtml.match(
      /<main\b[^>]*\bid=["']MainContent["'][^>]*>([\s\S]*?)<\/main>/i
    );
    if (match) {
      return {
        inner: match[1],
        title: (pageHtml.match(/<title[^>]*>([\s\S]*?)<\/title>/i) || [])[1] || null,
      };
    }

    try {
      var doc = new DOMParser().parseFromString(pageHtml, 'text/html');
      var main = doc.getElementById('MainContent');
      if (!main) return null;
      return {
        inner: main.innerHTML,
        title: doc.title || null,
      };
    } catch (e) {
      return null;
    }
  }

  function stripHeavyScriptsFromHtml(html) {
    // Keep JSON / template data scripts (variant picker + ProductJSON need these
    // for media-gallery updates after soft-nav). Strip executable scripts only.
    return String(html || '')
      .replace(
        /<script\b(?![^>]*type=["']application\/(?:ld\+)?json["'])(?![^>]*type=["']text\/template["'])[^>]*>[\s\S]*?<\/script>/gi,
        ''
      )
      .replace(/<script\b[^>]*\bsrc=["'][^"']+["'][^>]*>\s*<\/script>/gi, '');
  }

  function getSelectedVariantId() {
    // Soft-nav / deep links: URL is authoritative
    try {
      var fromUrl = new URLSearchParams(window.location.search).get('variant');
      if (fromUrl) return String(fromUrl);
    } catch (e) {}

    // Prefer main PDP hidden input — never cart-drawer / upsell forms
    var preferred = document.querySelectorAll(
      'input.product-variant-id[name="id"], form[id^="product-form-"] input[name="id"], form[id^="product-form-installment-"] input[name="id"], .product__info-container input[name="id"], product-info input[name="id"]'
    );
    for (var p = 0; p < preferred.length; p++) {
      var form = preferred[p].closest('form');
      var formId = ((form && form.id) || '') + ' ' + ((form && form.className) || '');
      if (/upsell|cart-drawer|drawerupsell/i.test(formId)) continue;
      if (preferred[p].value) return String(preferred[p].value);
    }

    var inputs = document.querySelectorAll('input[name="id"]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var f = input.closest('form');
      var fid = ((f && f.id) || '') + ' ' + ((f && f.className) || '');
      if (/upsell|cart-drawer|drawerupsell/i.test(fid)) continue;
      if (input.value) return String(input.value);
    }
    return '';
  }

  function getVariantsFromPage() {
    // Prefer variant picker JSON (includes featured_media). Skip ProductJSON-*
    // which is 3D model media and can look like a variant array.
    var nodes = document.querySelectorAll(
      'variant-selects > script[type="application/json"], variant-radios > script[type="application/json"], secondary-variant-select > script[type="application/json"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      try {
        var data = JSON.parse(nodes[i].textContent || 'null');
        if (!data) continue;
        if (Array.isArray(data) && data.length && data[0] && data[0].id != null && (data[0].option1 != null || data[0].options)) {
          return data;
        }
        if (data.variants && data.variants.length) return data.variants;
      } catch (e) {}
    }
    return [];
  }

  function findVariantById(variants, variantId) {
    if (!variantId) return null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) return variants[i];
    }
    return null;
  }

  function mediaIdFromVariant(variant) {
    if (!variant) return '';
    // Gallery data-media-id uses featured_media.id (≠ featured_image.id)
    if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
    return '';
  }

  function variantImageSrcHint(variant) {
    if (!variant) return '';
    if (variant.featured_media && variant.featured_media.preview_image) {
      return String(variant.featured_media.preview_image.src || '');
    }
    if (variant.featured_image) return String(variant.featured_image.src || '');
    return '';
  }

  function normalizeImgSrc(src) {
    var s = String(src || '').split('?')[0];
    try {
      if (s.indexOf('//') === 0) s = 'https:' + s;
      var u = new URL(s, window.location.origin);
      return u.pathname;
    } catch (e) {
      return s;
    }
  }

  function findGallerySlide(gallery, mediaId, srcHint) {
    var slide = null;
    if (mediaId) {
      slide =
        gallery.querySelector('.product__media-item[data-media-id$="-' + mediaId + '"]') ||
        gallery.querySelector('[data-media-id$="-' + mediaId + '"]') ||
        gallery.querySelector('[data-media-id="' + mediaId + '"]');
    }
    if (slide) return slide;

    var hint = normalizeImgSrc(srcHint);
    if (!hint) return null;
    var file = hint.split('/').pop();
    var candidates = gallery.querySelectorAll('.product__media-item[data-media-id], [id^="GalleryViewer"] [data-media-id]');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var img = el.querySelector('img');
      if (!img) continue;
      var src = normalizeImgSrc(img.currentSrc || img.src || img.getAttribute('src') || img.getAttribute('data-src') || '');
      if (!src) continue;
      if (src === hint || (file && src.indexOf(file) !== -1)) return el;
    }
    return null;
  }

  function activateGallerySlide(gallery, slide) {
    if (!gallery || !slide) return;
    var targetId = slide.getAttribute('data-media-id');
    if (!targetId) return;

    // Always apply classes first — theme setActiveMedia can throw if viewer
    // refs are stale after soft-nav innerHTML swap.
    var viewer = gallery.querySelector('[id^="GalleryViewer"]') || gallery;
    viewer.querySelectorAll('.product__media-item[data-media-id], [data-media-id]').forEach(function (el) {
      if (!el.classList.contains('product__media-item') && !el.closest('[id^="GalleryViewer"]')) return;
      el.classList.toggle('is-active', el.getAttribute('data-media-id') === targetId);
    });
    // Broader is-active toggle inside viewer only
    viewer.querySelectorAll('[data-media-id]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-media-id') === targetId);
    });

    gallery.querySelectorAll('[data-target]').forEach(function (thumb) {
      var btn = thumb.querySelector('button');
      if (!btn) return;
      if (thumb.getAttribute('data-target') === targetId) btn.setAttribute('aria-current', 'true');
      else btn.removeAttribute('aria-current');
    });

    try {
      if (slide.parentElement && typeof slide.parentElement.prepend === 'function') {
        slide.parentElement.prepend(slide);
      }
      var thumb = gallery.querySelector('[data-target="' + targetId + '"]');
      if (thumb && thumb.parentElement && typeof thumb.parentElement.prepend === 'function') {
        thumb.parentElement.prepend(thumb);
      }
    } catch (e2) {}

    try {
      if (viewer.slider && typeof viewer.resetPages === 'function') viewer.resetPages();
      if (typeof viewer.initPages === 'function') viewer.initPages();
      if (typeof viewer.update === 'function') viewer.update();
    } catch (e3) {}

    // Never enable filtering — slide data-alt is product title, not color.
    try {
      if (typeof gallery.setActiveMedia === 'function') {
        if (!gallery.elements) {
          gallery.elements = {
            liveRegion: gallery.querySelector('[id^="GalleryStatus"]'),
            viewer: gallery.querySelector('[id^="GalleryViewer"]'),
            thumbnails: gallery.querySelector('[id^="GalleryThumbnails"]'),
          };
        } else if (!gallery.elements.viewer) {
          gallery.elements.viewer = gallery.querySelector('[id^="GalleryViewer"]');
          gallery.elements.thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
        }
        gallery.setActiveMedia(targetId, true, false, null);
      }
    } catch (e) {}
  }

  function nudgeShrineVariantMedia(variant) {
    if (!variant || !variant.featured_media) return;
    document.querySelectorAll('variant-selects, variant-radios').forEach(function (el) {
      try {
        el.currentVariant = variant;
        if (typeof el.updateMedia === 'function') el.updateMedia(variant);
      } catch (e) {}
    });
  }

  function syncGalleryToSelectedVariant(forcedVariantId) {
    try {
      var variantId = forcedVariantId || getSelectedVariantId();
      var variants = getVariantsFromPage();
      var variant = findVariantById(variants, variantId);
      if (!variant) return false;

      var mediaId = mediaIdFromVariant(variant);
      var srcHint = variantImageSrcHint(variant);
      if (!mediaId && !srcHint) return false;

      var galleries = document.querySelectorAll('media-gallery');
      if (!galleries.length) return false;

      var synced = false;
      galleries.forEach(function (gallery) {
        var slide = findGallerySlide(gallery, mediaId, srcHint);
        if (!slide) return;
        activateGallerySlide(gallery, slide);
        synced = true;
      });

      nudgeShrineVariantMedia(variant);
      return synced;
    } catch (e) {
      return false;
    }
  }

  function bindVariantGallerySync() {
    document.querySelectorAll('variant-selects, variant-radios').forEach(function (el) {
      if (el.dataset.igGallerySync === '1') return;
      el.dataset.igGallerySync = '1';
      el.addEventListener('change', function () {
        setTimeout(function () {
          syncGalleryToSelectedVariant();
        }, 0);
        setTimeout(function () {
          syncGalleryToSelectedVariant();
        }, 60);
        setTimeout(function () {
          syncGalleryToSelectedVariant();
        }, 200);
      });
    });

    document.querySelectorAll('input.product-variant-id[name="id"], form[id^="product-form-"] input[name="id"]').forEach(function (input) {
      var form = input.closest('form');
      var formId = ((form && form.id) || '') + '';
      if (/upsell|cart-drawer/i.test(formId)) return;
      if (input.dataset.igGallerySync === '1') return;
      input.dataset.igGallerySync = '1';
      var obs = new MutationObserver(function () {
        syncGalleryToSelectedVariant();
      });
      obs.observe(input, { attributes: true, attributeFilter: ['value'] });
      input.addEventListener('change', function () {
        syncGalleryToSelectedVariant();
      });
    });
  }

  function scheduleGallerySync(forcedVariantId) {
    var id = forcedVariantId || getSelectedVariantId();
    syncGalleryToSelectedVariant(id);
    setTimeout(function () {
      syncGalleryToSelectedVariant(id);
    }, 50);
    setTimeout(function () {
      syncGalleryToSelectedVariant(id);
    }, 150);
    setTimeout(function () {
      syncGalleryToSelectedVariant(id);
    }, 350);
    setTimeout(function () {
      syncGalleryToSelectedVariant(id);
    }, 700);
    setTimeout(function () {
      syncGalleryToSelectedVariant(id);
    }, 1200);
  }

  function lightReinit(forcedVariantId) {
    document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
    if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
      try {
        Shopify.PaymentButton.init();
      } catch (e) {}
    }
    if (window.ComfoFeetSizeGenderConverter && typeof window.ComfoFeetSizeGenderConverter.init === 'function') {
      try {
        window.ComfoFeetSizeGenderConverter.init();
      } catch (e) {}
    }
    if (window.ComfofeetStickyAtcGender && typeof window.ComfofeetStickyAtcGender.apply === 'function') {
      try {
        window.ComfofeetStickyAtcGender.apply();
      } catch (e) {}
    }

    bindVariantGallerySync();
    scheduleGallerySync(forcedVariantId);
  }

  function scrollTopNow() {
    window.scrollTo(0, 0);
  }

  function fetchPageHtml(productUrl, signal) {
    return fetch(productUrl, {
      credentials: 'same-origin',
      signal: signal,
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(function (res) {
      if (!res.ok) throw new Error('page failed');
      return res.text();
    });
  }

  function loadPage(productUrl, signal) {
    var key = cacheKey(productUrl);
    if (cache[key]) return Promise.resolve(cache[key]);
    return fetchPageHtml(productUrl, signal).then(function (html) {
      var extracted = extractMainHtml(html);
      if (!extracted || !extracted.inner) throw new Error('no main');
      var payload = {
        inner: stripHeavyScriptsFromHtml(extracted.inner),
        title: extracted.title,
      };
      cache[key] = payload;
      return payload;
    });
  }

  function prefetch(url) {
    if (!url || !isVariantB()) return;
    var key = cacheKey(url);
    if (cache[key] || prefetching[key]) return;
    prefetching[key] = true;
    loadPage(url)
      .catch(function () {})
      .finally(function () {
        delete prefetching[key];
      });
  }

  function applyPayload(payload) {
    var main = document.getElementById('MainContent');
    if (!main || !payload || !payload.inner) return false;

    // Park most-loved outside main so soft-nav does not wipe it
    document.querySelectorAll(ROOT_SEL).forEach(function (root) {
      parkSection(root);
    });

    main.innerHTML = payload.inner;

    if (payload.title) {
      var tmp = document.createElement('textarea');
      tmp.innerHTML = payload.title;
      document.title = tmp.value;
    }
    return true;
  }

  function softNavigate(url) {
    if (!url) return;

    if (activeController) {
      try {
        activeController.abort();
      } catch (e) {}
    }

    busy = true;
    document.documentElement.classList.add('ig-most-loved-loading');

    var main = document.getElementById('MainContent');
    scrollTopNow();
    if (main) main.classList.add('ig-most-loved-slide-out');

    activeController = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var signal = activeController ? activeController.signal : undefined;

    var targetVariantId = '';
    try {
      targetVariantId = new URL(url, window.location.origin).searchParams.get('variant') || '';
    } catch (e) {}

    loadPage(url, signal)
      .then(function (payload) {
        if (!applyPayload(payload)) {
          window.location.href = url;
          return;
        }

        history.pushState({ igMostLoved: true }, '', url);

        if (main) {
          main.classList.remove('ig-most-loved-slide-out');
          main.classList.add('ig-most-loved-slide-in');
          setTimeout(function () {
            main.classList.remove('ig-most-loved-slide-in');
          }, 280);
        }

        scrollTopNow();

        requestAnimationFrame(function () {
          lightReinit(targetVariantId);
          apply();
          // Re-assert gallery after other PDP scripts settle
          setTimeout(function () {
            scheduleGallerySync(targetVariantId);
          }, 400);
        });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = url;
      })
      .finally(function () {
        busy = false;
        document.documentElement.classList.remove('ig-most-loved-loading');
        if (main) main.classList.remove('ig-most-loved-slide-out');
      });
  }

  function bindCards(root) {
    if (!root) return;
    root.querySelectorAll(CARD_SEL).forEach(function (card) {
      if (card.dataset.igBound === '1') return;
      card.dataset.igBound = '1';

      var url = card.getAttribute('data-product-url') || card.getAttribute('href');

      card.addEventListener('pointerenter', function () {
        prefetch(url);
      });
      card.addEventListener('focus', function () {
        prefetch(url);
      });
      card.addEventListener(
        'touchstart',
        function () {
          prefetch(url);
        },
        { passive: true }
      );

      card.addEventListener('click', function (event) {
        if (!isVariantB()) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (event.button && event.button !== 0) return;
        event.preventDefault();
        softNavigate(url);
      });
    });
  }

  function getHandleFromPath(pathname) {
    var match = String(pathname || '').match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function readProductIdFromMain() {
    var main = document.getElementById('MainContent');
    if (!main) return '';
    var el =
      main.querySelector('[data-product-id]') ||
      main.querySelector('input[name="product-id"]') ||
      main.querySelector('form[action*="/cart/add"] [name="product-id"]');
    if (el) {
      var id = el.getAttribute('data-product-id') || el.value || '';
      if (id) return String(id);
    }
    var jsonLd = main.querySelector('script[type="application/ld+json"]');
    if (jsonLd) {
      try {
        var data = JSON.parse(jsonLd.textContent || '{}');
        var nodes = Array.isArray(data) ? data : [data];
        for (var i = 0; i < nodes.length; i++) {
          var node = nodes[i];
          if (node && (node['@type'] === 'Product' || (node['@type'] || '').indexOf('Product') !== -1)) {
            var pid = node.productID || node.sku || (node.offers && node.offers.sku) || '';
            if (node['@id'] && /\/products\//.test(node['@id'])) {
              /* prefer numeric id from meta if present */
            }
          }
        }
      } catch (e) {}
    }
    var meta = document.querySelector('meta[property="product:id"], meta[name="product-id"]');
    if (meta && meta.content) return String(meta.content);
    return '';
  }

  function refreshRootProductContext(root) {
    return new Promise(function (resolve) {
      var handle = getHandleFromPath(window.location.pathname);
      if (!handle) {
        resolve(false);
        return;
      }

      var previousHandle = root.getAttribute('data-product-handle') || '';
      var previousId = root.getAttribute('data-product-id') || '';
      root.setAttribute('data-product-handle', handle);

      fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('product js failed');
          return res.json();
        })
        .then(function (product) {
          if (!product) throw new Error('empty product');
          var gender = detectGenderFromProduct(product);
          // Prefer live MEN/WOMEN tab when present (unisex PDPs)
          var tab = document.querySelector('.custom-gender-tab.active[data-gender]');
          if (tab && !womenOnlyProduct(product)) {
            gender = tab.getAttribute('data-gender') === 'women' ? 'women' : 'men';
          }
          root.setAttribute('data-product-id', String(product.id || previousId || ''));
          root.setAttribute('data-product-gender', gender);
          resolve({
            changed:
              String(product.id) !== String(previousId) || handle !== previousHandle,
            product: product,
            gender: gender,
          });
        })
        .catch(function () {
          var id = readProductIdFromMain() || previousId;
          if (id) root.setAttribute('data-product-id', String(id));
          var gender = getRootGender(root);
          root.setAttribute('data-product-gender', gender);
          resolve({ changed: handle !== previousHandle, product: null, gender: gender });
        });
    });
  }

  function resetTrackForRecommendations(root) {
    var track = root.querySelector('[data-ig-most-loved-track]');
    if (!track) return;
    track.innerHTML =
      '<div class="ig-most-loved-styles__loading" data-ig-most-loved-recommendations>Loading styles…</div>';
  }

  function apply() {
    applyDev();
    document.documentElement.classList.toggle('ig-most-loved-styles-b', isVariantB());
    if (!isVariantB()) return;

    document.querySelectorAll(ROOT_SEL).forEach(function (root) {
      positionAboveFaq(root);

      var previousId = root.getAttribute('data-product-id') || '';
      var previousHandle = root.getAttribute('data-product-handle') || '';
      var needsFetch = !!root.querySelector('[data-ig-most-loved-recommendations]');

      refreshRootProductContext(root).then(function (ctx) {
        if (!ctx) return;

        var nextHandle = root.getAttribute('data-product-handle') || '';
        var nextId = root.getAttribute('data-product-id') || '';
        var productChanged =
          (previousId && nextId && String(previousId) !== String(nextId)) ||
          (previousHandle && nextHandle && previousHandle !== nextHandle);

        var gender = (ctx && ctx.gender) || root.getAttribute('data-product-gender') || getRootGender(root);
        root.setAttribute('data-product-gender', gender);

        var genderMismatch = !cardsMatchGender(root, gender);
        var firstCard = root.querySelector(CARD_SEL);
        var firstId = firstCard && firstCard.getAttribute('data-product-id');
        var curatedDefs = getCuratedSlotDefs(root, nextHandle);
        var isCurated = curatedDefs.length > 0;
        var missingCurrent =
          !isCurated &&
          !!nextId &&
          (!firstCard || (firstId && String(firstId) !== String(nextId)));

        // Curated shelves: always rebuild via product.js so variant featured_image is correct
        var curatedNeedsRefresh = false;
        if (isCurated && firstCard) {
          var expected = curatedDefs[0];
          var firstHandle = firstCard.getAttribute('data-product-handle') || '';
          var firstVid = firstCard.getAttribute('data-variant-id') || '';
          if (expected && firstHandle !== expected.handle) curatedNeedsRefresh = true;
          if (
            expected &&
            expected.variantId &&
            firstVid &&
            String(firstVid) !== String(expected.variantId)
          ) {
            curatedNeedsRefresh = true;
          }
          // If card img looks like a generic product featured (no data check) — rebuild once
          if (!root.getAttribute('data-curated-hydrated')) curatedNeedsRefresh = true;
        } else if (isCurated && !firstCard) {
          curatedNeedsRefresh = true;
        }

        if (
          productChanged ||
          needsFetch ||
          genderMismatch ||
          missingCurrent ||
          curatedNeedsRefresh ||
          root.querySelector('[data-ig-most-loved-recommendations]')
        ) {
          resetTrackForRecommendations(root);
          loadRecommendations(root);
          if (isCurated) root.setAttribute('data-curated-hydrated', '1');
          return;
        }

        root.querySelectorAll('.ig-most-loved-styles__gender').forEach(function (label) {
          label.textContent = genderLabel(gender);
        });
        bindCards(root);
      });

      bindCards(root);
      root.querySelectorAll(CARD_SEL).forEach(function (card, index) {
        if (index > 3) return;
        var url = card.getAttribute('data-product-url') || card.getAttribute('href');
        setTimeout(function () {
          prefetch(url);
        }, 400 + index * 250);
      });
    });
  }

  function boot() {
    apply();
    bindVariantGallerySync();
    scheduleGallerySync();

    document.addEventListener('variant:change', function () {
      scheduleGallerySync();
    });

    window.addEventListener('popstate', function () {
      if (!isVariantB()) return;
      softNavigate(window.location.href);
    });

    document.addEventListener('click', function (event) {
      var tab = event.target && event.target.closest && event.target.closest('.custom-gender-tab[data-gender]');
      if (!tab || !isVariantB()) return;
      setTimeout(function () {
        document.querySelectorAll(ROOT_SEL).forEach(function (root) {
          var gender = getRootGender(root);
          root.setAttribute('data-product-gender', gender);
          resetTrackForRecommendations(root);
          loadRecommendations(root);
        });
      }, 50);
    });

    if (document.body && window.MutationObserver) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === BODY_ATTR) {
            apply();
            break;
          }
        }
      }).observe(document.body, {
        attributes: true,
        attributeFilter: [BODY_ATTR],
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.ComfofeetMostLovedStyles = {
    apply: apply,
    softNavigate: softNavigate,
    prefetch: prefetch,
    formatCount: formatCount,
    positionAboveFaq: positionAboveFaq,
  };
})();
